import React from "react";
import submit from "submit-form";
import Modal from "../../modal-new";

export const RemoveDefaultTemplateModal = ({
  defaultTemplateName,
  defaultTemplateId,
  organizationCoachId
}) => {
  const handleRemoveDefaultTemplate = () => {
    let body = { removeDefault: true };

    if (organizationCoachId) {
      body = { ...body, organizationCoachId };
    }

    submit("/actions/annual-planner/remove-default-template", {
      method: "POST",
      body,
    });
  };

  return (
    <Modal
      className={`annual-planner-modal remove-default-template-modal`}
      title="Remove default template"
    >
      <div className="body">
        <div className="warning-wrapper">
          <span className="chip warning">
            You are about to remove the default template:{" "}
            <span style={{ color: "var(--white-38)" }}>
              {defaultTemplateName}
            </span>
          </span>
          <p>Are you sure you want to continue?</p>
        </div>
      </div>
      <footer>
        <button
          onClick={handleRemoveDefaultTemplate}
          role="button"
          data-action="delete"
        >
          <img src="/img/new-icons/red-trash.svg" />
          Delete
        </button>
        <button
          onClick={() =>
            submit("/actions/refresh", {
              method: "GET",
              body: { "modal[type]": "phase-templates" },
            })
          }
          role="button"
          data-action="cancel"
          data-button-type="tertiary"
        >
          Cancel
        </button>
      </footer>
    </Modal>
  );
};
